import React, { FunctionComponent, useContext } from 'react';
import { PageHeader } from '../../components';
import { BrandStore } from '../../context';
import {
  SubmissionCompleteContainer,
  ContactButton,
} from '../../components/SubmissionComplete';

export const StandaloneDocumentsConfirmationPage: FunctionComponent = () => {
  const {
    state: { brand },
  } = useContext(BrandStore);

  const { regStandaloneDocumentsHeader } = brand || {};

  return (
    <>
      <PageHeader
        header={regStandaloneDocumentsHeader}
        id="standalone-documents-page-header"
        data-testid="standalone-documents-page-header"
        description=""
      />
      <SubmissionCompleteContainer />
      <ContactButton />
    </>
  );
};
